import React, { Component, Fragment } from 'react';
import ReactTable from 'react-table';
import NotificationSystem from 'react-notification-system';
import { BeatLoader } from 'react-spinners';
import moment from 'moment';
import Modal from 'react-modal'
import Datetime from 'react-datetime';
import { BULK_TRANS_TYPE, MealTypesReports, MenuOrderTypes, currency_symbol, date_format } from '../../../../server/constants';
import TmExportExcel from '../../../Misc/tmExportExcel/tmExportExcel';
import { _delete, get } from '../../../../server/actions';
import {
    _addNotificationError, groupBy, isRegularLunchOrderType, showFile, getSchoolGrades,
    convertTwoDecimalPoint, getWeekStartEndDates, getMonthStartEndDates,
    getTodayStartEndDates, getSessionStartEndDates, getLastMonthStartEndDates, _addNotification, getCEPBulkTransactionsType
} from '../../../../server/util'
import DateRangePicker from 'react-bootstrap-daterangepicker';
import DateTimeRangePicker from '../../../Misc/DateTimeRangePicker'
const _ = require('lodash');
const valid = (current) => {
    /* let maxDate = moment().add(2, 'months');
    if (current <= maxDate) {
        return current.day() !== 0 && current.day() !== 6;
    }
    else {
        return false;
    } */
    return true;
};
const enumMealType = {
    lunch: 'Lunch',
    breakfast: 'Breakfast',
    milk: 'Milk',
    snack: 'Snack',
    dinner: 'Dinner'
}
const mealsData = {
    Lunch: 'Lunch Served',
    Breakfast: 'Breakfast Served',
    Snack: 'Snack Served',
    Dinner: 'Dinner Served'
};
const deleteStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        width: '30%',
        transform: 'translate(-50%, -50%)'
    }
};
class BulkPurchases extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            data: [],
            startDate: moment(),
            endDate: moment(),
            dataFilter: { tdate: 'D', sdate: new Date(), edate: new Date() },
            deletePurchaseModel: false,
            deleteRec: undefined,
            mealType: enumMealType.lunch,
            selectedDates: {
                //startDate: moment(moment((this.props.activeMonth || moment()), 'YYYYMM')).startOf('month'),
                //endDate: moment(moment((this.props.activeMonth || moment()), 'YYYYMM')).endOf('month')
                startDate: moment().startOf('D'),
                endDate: moment().endOf('D'),
            },
        }
    }
    componentDidMount() {
        this._notificationSystem = this.refs.notificationSystem;
        this.getData(false, this.state.startDate, this.state.endDate);

    }
    onChangeDateRange = (startDate, endDate) => {
        let _selectedDate = { startDate: startDate, endDate: endDate }
        this.setState({ selectedDates: _selectedDate },
            this.getData(false, startDate, endDate)
        );
    }

    getData = (isPdf = false, startDate, endDate) => {
        let userInfo = JSON.parse(sessionStorage.getItem('loggedInUserInfo'));
        const { mealType, } = this.state;
        this.setState({ loading: true });
        const sDate = moment(startDate).startOf('D');
        const eDate = moment(endDate).endOf('D')
        let url = ''
        if (isPdf) {
            url = `/cep/reports/${userInfo.schoolId}/purchaseTransactions/${mealType}?startDate=${moment(sDate).utc().format("YYYY-MM-DDTHH:mm:ss")}&endDate=${moment(eDate).utc().format("YYYY-MM-DDTHH:mm:ss")}&isExport=true&access_token=`;

        } else {
            url = `/cep/reports/${userInfo.schoolId}/purchaseTransactions/${mealType}?startDate=${moment(sDate).utc().format("YYYY-MM-DDTHH:mm:ss")}&endDate=${moment(eDate).utc().format("YYYY-MM-DDTHH:mm:ss")}&access_token=`;
        }

        get(url).then((response) => {
            if (!response.ok) {
                if (response.status === 417) {
                    return response.json();
                }
                //throw Error(response.errorMessage);
            }
            console.log('response', response);
            return response;
        }).then(res => {
            if (res.statusCode === 417) {
                // _addNotificationError(res.statusMessage,this)
                throw Error(res.statusMessage);
            } else if (!res.statusCode === 200) {
                throw Error(res.errorMessage);
            } else {
                if (isPdf) {
                    return res.blob();
                } else {
                    return res.json();
                }
            }
        }).then(data => {
            if (isPdf) {
                let filename = 'adjustment_Report.pdf';
                showFile(data, filename);
                this.setState({ loading: false });
            } else {
                this.setState({
                    data: data.resp, loading: false
                })
            }
        }).catch(
            (error) => {
                let msg = ''
                if (typeof error === 'string') {
                    msg = error;
                } else {
                    msg = error.message;
                }
                _addNotificationError(msg, this);
                this.setState({ loading: false })
            }
        );
    }
    buildAdjustmentReportFormatForExport = () => {
        let fData = [];
        let result = [];
        (this.state.data || []).map(row => {
            fData.push([
                row.itemName,
                row.grade,
                row.menuType,
                row.totalQty,
                moment(row.transactionDate).isValid()?moment(row.transactionDate).format('YYYY-MM-DD HH:mm:ss') : '',
                row.trxId,
                row.deviceId,
                row.createdBy,
                row.teacherName
            ]);
        });

        result.push(
            {
                columns: ['Item:', 'Grade', 'Menu Type', 'Total Qty', 'Trx Date', 'Trx Id', 'Device Id', 'Created By', 'Teacher'],
                data: fData
            }
        );
        return result;

    }
    renderInput = (props, openCalendar, closeCalendar) => {
        return (
            <div>
                <input {...props} />
                <button type="button" className="input-group-addon" onClick={openCalendar}>
                    <i className="fa fa-calendar"> </i>
                </button>
            </div>
        );
    }
    setDate = (e) => {
        //alert(e)
        this.refs.calendar.closeCalendar()
        this.setState({ startDate: e }, () => {
            this.getData()
        })
    }
    deletePurchaseRec = () => {
        const { deleteRec } = this.state;
        const url = `/cep/transactions/${deleteRec.original.trxId}/${deleteRec.original.trxMenuId || 0}?access_token=`;
        _delete(url)
            .then((response) => {
                if (!response.ok) {
                    throw Error(response.statusText);
                } else {
                    return response.json();
                }
            }).then((response) => {
                if (response.statusCode === 200) {
                    this.setState({ loading: false, deletePurchaseModel: false })
                    _addNotification(response.statusMessage, this);
                    this.getData()
                } else {
                    throw Error(response.errorMessage);
                }
            }).catch(
                (error) => {
                    this.setState({ loading: false })
                    _addNotificationError(error.message, this);
                }
            );

    }
    render() {
        const checkboxProps = {
            getTheadProps: () => {
                return {
                    style: {
                        backgroundColor: "#D2D7D4", fontWeight: 'bold'
                        // color: selected ? 'white' : 'inherit',
                    },
                    className: "bg-success base-reverse"
                };
            },
            getTableProps: () => {
                return {
                    className: "table table-hover"
                }
            },
        };


        return (
            <Fragment>
                <NotificationSystem ref="notificationSystem" />
                <div className='sweet-loading'
                    style={{ position: 'fixed', top: '50%', left: '48%', zIndex: '1000' }}>
                    <BeatLoader
                        size={20}
                        color={'#ea7066'}
                        loading={this.state.loading}
                    />
                </div>
                <div className="panel panel-p1 panel-primary">

                    <div className="panel-heading text-center">
                        <h3 className="panel-title" style={{ display: 'inline' }}>Bulk Purchases</h3>
                        <div style={{
                            display: 'inline-block',
                            backgroundColor: 'transparent',
                            marginTop: '-7px',
                            float: 'right',
                            borderRadius: '3px'
                        }}>
                            <div className="btn-group">
                                <button className="btn-link btn-sm dropdown-toggle" type="button"
                                    data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" style={{ color: '#fff', fontSize: '13px' }}>
                                    <i className="fa fa-file" aria-hidden="true"></i> Export <span className="caret"></span>
                                </button>
                                <ul className="dropdown-menu">
                                    <li>
                                        <a title="Click to Download PDF" style={{ cursor: 'pointer' }}
                                            onClick={() => { this.getData(true, this.state.selectedDates.startDate, this.state.selectedDates.endDate); }}
                                            target='_blank'
                                        ><i className="fa fa-file-pdf-o" /> Pdf</a>
                                    </li>
                                    <li>
                                        <TmExportExcel id="adjustmentReport"
                                            name={"Bulk Transactions Report"}
                                            filename={"Bulk Transactions Report"}
                                            element={<a title="Click to Download Excel" id="adjustmentReport"
                                                style={{
                                                    display: 'block',
                                                    padding: '3px 20px',
                                                    clear: 'both',
                                                    fontWeight: '400',
                                                    lineHeight: 1.42857143,
                                                    color: '#333',
                                                    whiteSpace: 'nowrap',
                                                    cursor: 'pointer'
                                                }}
                                            ><i className="fa fa-file-excel-o" /> Excel</a>}
                                            dataSet={this.buildAdjustmentReportFormatForExport()}
                                        />
                                    </li>

                                </ul>
                            </div>
                        </div>
                    </div>
                    <div className="panel-body">
                        <div className='row'>
                            <div className='col-md-2' style={{ marginTop: '4px' }}>
                                <label>Select date range:</label>
                            </div>
                            <div className='col-md-3' style={{ marginTop: '4px' }}>
                                <DateTimeRangePicker
                                    startDate={this.state.selectedDates.startDate}
                                    endDate={this.state.selectedDates.endDate}
                                    isReport={false}
                                    applyCallback={(event, picker) => {
                                        this.onChangeDateRange(picker.startDate, picker.endDate)
                                    }}
                                    isDateShow={true} />
                            </div>
                            <div className='col-md-2' style={{ marginTop: '4px' }}>
                                <label className='custom-label' >Report For</label>
                            </div>
                            <div className="col-md-2">
                                <select className='form-control' value={this.state.mealType} onChange={(e) => {
                                    this.setState({ mealType: e.target.value }, () => {
                                        this.getData()
                                    });
                                }}>
                                    {
                                        Object.keys(enumMealType).map((type, key) => {
                                            return <option value={enumMealType[type]}>{enumMealType[type]}</option>
                                        })
                                    }
                                </select>
                            </div>
                        </div>
                        <div className='row' >
                            <div className="col-md-12" style={{ marginTop: '4px' }}>
                                <ReactTable ref={(r) => this.deptTable = r} id={'deptTbl'}
                                    filterable
                                    columns={[
                                        {
                                            Header: "Item",
                                            id: "itemName",
                                            width: 200,
                                            style: { textAlign: 'left' },
                                            accessor: row => {
                                                let itemName = ''
                                                if (getCEPBulkTransactionsType() == BULK_TRANS_TYPE.MEALCOUNT) {
                                                    itemName = mealsData[row.menuType];
                                                } else {
                                                    itemName = row.itemName;
                                                }
                                                return (
                                                    <span>
                                                        {itemName}
                                                    </span>
                                                );
                                            },
                                            filterMethod: (filter, row) => {
                                                const _row = row._original
                                                return (_row.itemName).toLowerCase().startsWith(filter.value.toLowerCase())
                                            },
                                            Footer: (props) => {
                                                const { data } = props;
                                                const tempList = (data).map(d => d._original);
                                                return <div style={{ textAlign: "center" }}>Total:  {tempList.length}</div>
                                            }
                                        },
                                        {
                                            Header: 'Created By',
                                            accessor: 'createdBy',
                                            width: 200,
                                            filterMethod: (filter, row) => {
                                                const _row = row._original
                                                return (_row.createdBy).toLowerCase().startsWith(filter.value.toLowerCase())
                                            }
                                        }, {
                                            Header: 'Served On',
                                            id: 'transactionDate',
                                            width: 200,
                                            accessor: row => {
                                                return (
                                                    <div style={{ textAlign: "center" }}>
                                                        {moment(row.transactionDate, 'MM/DD/YYYY hm:mm:ss tt').isValid() ? moment(row.transactionDate, 'MM/DD/YYYY hh:mm:ss tt').format(`${date_format()} hh:mm`) : ''}
                                                    </div>
                                                );
                                            }

                                        },
                                        {
                                            Header: 'Device Id',
                                            accessor: 'deviceId',
                                            width: 150,
                                            filterMethod: (filter, row) => {
                                                const _row = row._original
                                                return (_row.deviceId).toLowerCase().startsWith(filter.value.toLowerCase())
                                            }
                                        },

                                        {
                                            Header: "Grade",
                                            id: "grade",
                                            style: { textAlign: 'center' },
                                            width: 100,
                                            accessor: row => {
                                                return (
                                                    <span>
                                                        {row.grade}
                                                    </span>
                                                );
                                            },
                                            filterMethod: (filter, row) => {
                                                const _row = row._original
                                                return (_row.grade).toLowerCase().startsWith(filter.value.toLowerCase())
                                            }
                                        },
                                        {
                                            Header: `Total Qty`,
                                            id: 'totalQty',
                                            width: 100,
                                            filterable: false,
                                            accessor: row => {
                                                let Qty = 0;
                                                if (getCEPBulkTransactionsType() == BULK_TRANS_TYPE.MEALCOUNT) {
                                                    Qty = row.totalQty;
                                                } else {
                                                    Qty = row.qty;
                                                }

                                                return (
                                                    <div style={{ textAlign: "center" }}>
                                                        {Qty}
                                                    </div>
                                                );
                                            },
                                            Footer: (props) => {
                                                const { data } = props;
                                                const tempList = (data).map(d => d._original);
                                                if (getCEPBulkTransactionsType() == BULK_TRANS_TYPE.MEALCOUNT) {
                                                    return <div style={{ textAlign: "center" }}> {_.sum(_.map(tempList, d => d.totalQty))}</div>
                                                } else {
                                                    return <div style={{ textAlign: "center" }}> {_.sum(_.map(tempList, d => d.qty))}</div>
                                                }
                                            }
                                        },
                                        {
                                            Header: `Action`,
                                            id: 'action',
                                            width: 100,
                                            filterable: false,
                                            Cell: row => {
                                                return (
                                                    <a title="Delete Transaction" onClick={() => {
                                                        this.setState({ deletePurchaseModel: true, deleteRec: row })
                                                    }}><b><i className="fa tbl-rounded-icon fa-icon fa-trash bg-color-3"></i></b></a>
                                                )
                                            }
                                        }

                                    ]}
                                    data={_.orderBy(this.state.data, ['studentLName', 'studentFName'], ['asc'])}
                                    defaultPageSize={10} className="-striped -highlight" {...checkboxProps} />
                            </div>
                        </div>
                    </div>
                </div>
                <Modal
                    isOpen={this.state.deletePurchaseModel}
                    onRequestClose={() => this.setState({ deletePurchaseModel: false, deleteRec: undefined })}
                    style={deleteStyles}
                    contentLabel="Publish">
                    <div className="modal-header">
                        <h4 className="modal-title modal-title-color" id="deleteLabel">Deleting a Transaction</h4>
                    </div>
                    <div className="modal-body">
                        <p>Are you sure you want to continue?</p>
                    </div>
                    <div className="text-right">
                        <button type="button" className="btn btn-primary btn-xs" style={{ margin: '0' }}
                            onClick={() => this.setState({ deletePurchaseModel: false, deleteRec: undefined })}><i
                                className="glyphicon glyphicon-remove"
                                style={{ marginRight: '0', paddingLeft: '0' }}></i> No
                        </button>
                        <button type="button" className="btn btn-success btn-xs"
                            style={{ margin: '0 0 0 5px' }} onClick={this.deletePurchaseRec}
                            id="deleteConfirm"><i className="glyphicon glyphicon-ok"></i> Yes
                        </button>
                    </div>
                </Modal>

            </Fragment>
        );
    }
}

export default BulkPurchases;


// WEBPACK FOOTER //
// ./src/components/SchoolAdmin/Reports/FinancialReport/bulkPurchases.js